import { createBrowserRouter } from "react-router-dom";
import Dashboard from "../Pages/Dashboard";
import AdminSectionManager from "../Pages/AdminSectionManager";
import AdminBlogForm from "../Pages/AdminBlogForm";
import AllBlogsPage from "../Pages/AllBlogsPage";
import SeoSettings from "../Pages/SeoSettings";
import AdminServicesManager from "../Pages/AdminServicesManager";
import TestimonialForm from "../Pages/TestimonialForm";
import PrivateRoutes from "./PrivateRoutes";
import Login from "../Pages/Login";

export const router = createBrowserRouter([
  {
    path: "/",
    // element: (
    //   <ProtectedRoute>
    //     <Dashboard />
    //   </ProtectedRoute>
    // ),
    element: (
      <PrivateRoutes>
        <Dashboard />
      </PrivateRoutes>
    ),
    children: [
      {
        path: "/",
        element: (
          <PrivateRoutes>
            <AdminSectionManager />
          </PrivateRoutes>
        ),
      },
      {
        path: "/blogs",
        element: (
          <PrivateRoutes>
            <AllBlogsPage />
          </PrivateRoutes>
        ),
      },
      {
        path: "/add-blog",
        element: (
          <PrivateRoutes>
            <AdminBlogForm />
          </PrivateRoutes>
        ),
      },
      {
        path: "/testimonials",
        element: (
          <PrivateRoutes>
            <TestimonialForm />
          </PrivateRoutes>
        ),
      },
      {
        path: "/seo-setting",
        element: (
          <PrivateRoutes>
            <SeoSettings />
          </PrivateRoutes>
        ),
      },
      {
        path: "/manage-services",
        element: (
          <PrivateRoutes>
            <AdminServicesManager />
          </PrivateRoutes>
        ),
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
]);
